import { render, staticRenderFns } from "./RecipientChannelCheckboxGroup.vue?vue&type=template&id=1b5e5c0d"
import script from "./RecipientChannelCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./RecipientChannelCheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports